import { render } from "./AboutS17.vue?vue&type=template&id=423cdb64&scoped=true"
import script from "./AboutS17.vue?vue&type=script&lang=js"
export * from "./AboutS17.vue?vue&type=script&lang=js"

import "./AboutS17.vue?vue&type=style&index=0&id=423cdb64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423cdb64"]])

export default __exports__